{
    "global": {
        "title": {
            "messages": "Berichten",
            "planning": "Planning"
        },
        "error": {
            "network": "Netwerkfout!",
            "not-found": "Deze pagina bestaat niet!",
            "no-data": "Er zijn geen gegevens",
            "no-picture-selected": "Geen afbeelding geselecteerd!"
        },
        "success": {
            "deleted": "Het element is succesvol verwijderd!",
            "ai-answers-completed": "AI-mediaverwerking is voltooid, antwoorden zijn toegevoegd."
        },
        "btn": {
            "close": "Sluiten",
            "next": "Volgende",
            "refresh-packages": "Pakketten vernieuwen",
            "back-to-main-page": "Terug naar de hoofdpagina",
            "additional-information": "Aanvullende informatie",
            "back": "Terug",
            "delete": "Verwijderen",
            "cancel": "Annuleren",
            "edit": "Bewerken",
            "save": "Opslaan",
            "add": "Toevoegen",
            "send": "Verzenden",
            "submit": "Indienen",
            "reset": "Herstellen"
        },
        "datepicker": {
            "ok": "Ok",
            "cancel": "Annuleren"
        },
        "offline-status": {
            "airplane-mode": "Vliegtuigmodus is ingeschakeld"
        },
        "text": {
            "no-data": "geen gegevens",
            "results": "resultaat/resultaten",
            "all": {
                "f": "Alle",
                "m": "Allen"
            },
            "others": "andere",
            "none": {
                "f": "Geen",
                "m": "Geen"
            },
            "m2": "m2",
            "bool": {
                "true": "Ja",
                "false": "Nee",
                "none": " "
            }
        },
        "locale": {
            "fullStdDatePattern": "MM/DD/YYYY - HH:mm:ss",
            "fullDatePattern": "MM/DD/YYYY - HH:mm",
            "onlyDatePattern": "MM/DD/YYYY",
            "datePattern": "dddd, MMMM D",
            "timePattern": "HH:mm"
        },
        "validator": {
            "mandatoryField": "Vul alstublieft gegevens in voor dit veld! Dit is verplicht!",
            "only-images": "Alleen afbeeldingsbestanden zijn toegestaan!"
        },
        "info-modal": {
            "title": "Informatie over de applicatie",
            "label": {
                "last-sync": "Laatste synchronisatie",
                "application-version": "Applicatieversie",
                "show-hidden-questions": "Verborgen vragen weergeven",
                "show-debug-mode": "Debugmodus",
                "save-logs": "Logs opslaan",
                "send-logs": "Logs verzenden",
                "synchro": "Synchroniseren",
                "save": "Opslaan",
                "downloaded-prod-images": "Gedownloade productafbeeldingen",
                "send-db": "Database verzenden",
                "load-db": "Database laden",
                "db-warning": "Waarschuwing: dit zal alle huidige lokale gegevens vervangen!",
                "replace-db": "Huidige database vervangen door",
                "refresh-list": "Winkellijst vernieuwen",
                "choose-db": "Kies een databasebestand",
                "send-photos": "Foto's verzenden",
                "load-photos": "Foto's laden",
                "photos-count": "foto's geüpload",
                "download-photos": "Foto's downloaden",
                "no-photos-set": "Geen fotoset beschikbaar voor deze gebruiker.",
                "photos-replace-warning": "Waarschuwing: lokale foto's worden vervangen door de foto's van de server. Doorgaan?",
                "confirm-load-photos": "Foto's laden",
                "no-photos-to-send": "Geen foto's om te verzenden.",
                "photos-sent-success": "foto's verzonden",
                "photos-loaded-success": "Foto's succesvol geladen!"
            }
        },
        "pos-debug-block": {
            "label": {
                "pos-id": "Pos ID",
                "mission-planning-id": "Mission planning ID",
                "mission-id": "Mission ID",
                "reading-id": "Reading ID",
                "reading-history-id": "Reading history ID",
                "concurrent-reading-id": "Concurrent reading ID/datum"
            }
        }
    },
    "top-left-menu": {
        "home": "Startpagina",
        "planning": "Planning",
        "point-of-sale": "Verkooppunten",
        "messages": "Berichten",
        "debug": "Debug",
        "store-list": "Winkellijst",
        "login": "Inloggen",
        "contacts": "Contacten"
    },
    "top-right-menu": {
        "logout": "Uitloggen",
        "debug": "Debug",
        "store-list": "Winkellijst",
        "bo-link": "BO-ruimte",
        "login": "Inloggen"
    },
    "auth": {
        "login": {
            "title": "Login",
            "form": {
                "label": {
                    "login": "Gebruikersnaam",
                    "password": "Wachtwoord"
                },
                "btn": "Login",
                "validation_messages": {
                    "email": "Voer een geldig e-mailadres in",
                    "password": "Voer een wachtwoord in"
                }
            },
            "error": {
                "bad_credentials": "Ongeldig e-mailadres of wachtwoord"
            }
        }
    },
    "home": {
        "alert": {
            "readings-not-updated": "Kan antwoorden niet van de server ophalen. Lokale gegevens moeten eerst worden verzonden!"
        }
    },
    "post-it": {
        "config": {
            "label": {
                "conversations": "gesprek",
                "pos_code": "POS-code"
            },
            "message": {
                "no-threads": "Er zijn geen discussiedraden"
            }
        },
        "thread-details": {
            "messenger": {
                "text-input": "Aa.."
            },
            "edit-modal": {
                "title": "Bericht bewerken"
            }
        },
        "point-of-sale": {
            "choose-pos-modal": {
                "title": "Verkooppunt kiezen",
                "form": {
                    "labels": {
                        "pos": "Selectie van verkooppunt"
                    },
                    "errors": {
                        "unselected-pos": "Er is geen verkooppunt geselecteerd!"
                    }
                }
            }
        },
        "message": {
            "author-last-message": "Auteur laatste bericht:",
            "empty-thread": "Geen berichten in deze discussie",
            "connecting": "Verbinden...",
            "author-me": "Ik",
            "templates": "Vooraf gedefinieerde berichten",
            "template-1": "Aanvraag DMF-bezoek",
            "template-2": "Aanvraag commerciële info van de cyclus",
            "template-3": "De klant wil een bestelling plaatsen",
            "template-4": "De klant wil informatie over de levering van zijn bestelling",
            "template-5": "De klant wil zijn verkopen niet geven, kunt u ze doorgeven aan de projectleider?",
            "template-6": "Ik heb een officieuze uitdaging opgezet",
            "template-7": "De klant heeft zijn uitdaging gehaald",
            "template-8": "De klant wil een afspraak maken",
            "template-9": "De klant wil een product terugsturen",
            "template-10": "De klant wil een product ruilen"
        }
    },
    "point-of-sale": {
        "title": "Verkooppunten voor",
        "filter-form": {
            "label": {
                "search": "Zoeken in naam, adres, postcode",
                "store": "Winkelketen",
                "department": "Departement",
                "sort-by": "Sorteer op"
            },
            "sort-options": {
                "date-asc": "Laatste opnamedatum (oud → nieuw)",
                "date-desc": "Laatste opnamedatum (nieuw → oud)",
                "score-asc": "Perfect Store (laag → hoog)",
                "score-desc": "Perfect Store (hoog → laag)"
            }
        }
    },
    "planning": {
        "filter": {
            "label": {
                "select-year": "Selecteer het jaar",
                "select-week": "Selecteer de week",
                "today": "Vandaag"
            }
        },
        "list": {
            "week-nb": "Week nr."
        },
        "views": {
          "calendar-view": "Kalenderweergave",
          "timeline-view": "Tijdlijnweergave"
        },
        "periods": {
          "day": "Dag",
          "week": "Week",
          "month": "Maand"
        },
        "message": {
            "no-rdv": "Geen afspraken voor deze week!",
            "no-reads": "Er zijn geen gegevens!",
            "to-remove": "Deze planning is niet beschikbaar! Hij is verwijderd!",
            "no-reading-history": "Er is geen opnamegeschiedenis",
            "transmission-in-progress": "Overdracht bezig… link niet beschikbaar."
        }
    },
    "mission": {
        "block": {
            "pos": {
                "title": "Winkel-info"
            },
            "plan-a-visit": {
                "title": "Mijn bezoek voorbereiden",
                "text": "Bezoek Winkel op {day}, {date} van {start_hour} tot {end_hour}",
                "btn": "Mijn bezoek voorbereiden"
            },
            "my-visit": {
                "title": "Mijn bezoek",
                "start": "Begin van mijn bezoek",
                "end": "Einde van mijn bezoek",
                "btn": "Mijn opname uitvoeren"
            }
        }
    },
    "mission-planning": {
        "top-menu": {
            "questionnaires": "Mijn vragenlijsten",
            "visit-info": "Mijn bezoek",
            "whaly-link-focus": "Analyse focus",
            "whaly-link-sector": "Analyse sector",
            "actions": "Acties",
            "new-visit": "Nieuw bezoek",
            "edit-mission-planning": "Bewerken",
            "delete-mission-planning": "Verwijderen",
            "barcode-title": "Barcode"
        },
        "qst": {
            "info-pos": {
                "title": "Winkel-info",
                "label": {
                    "typology": "Typologie",
                    "secondary-typology": "Secundaire typologieën",
                    "select-secondary-typology": "Secundaire typologie selecteren",
                    "last-visit-date": "Datum laatste bezoek",
                    "frequency": "Frequentie",
                    "pos-contacts": "Contacten verbonden aan het verkooppunt",
                    "sign": "Winkelketen",
                    "additional-address": "Aanvullend adres",
                    "central": "Centrale",
                    "warehouse": "Magazijn",
                    "network": "Netwerk",
                    "surface": "Oppervlakte",
                    "commercial": "Commercieel",
                    "ca": "Omzet",
                    "sector": "Sector",
                    "present-in-pos": "Aanwezig in verkooppunt"
                }
            },
            "statistics" : {
                "last-reading": "Laatste meting",
                "current-reading": "Huidige meting",
                "labels": {
                    "DETAIL_DN": "DN",
                    "DETAIL_DNO": "DNO"
                }
            },
            "my-questionnaires": {
                "title": "Mijn vragenlijsten",
                "label": {
                    "optional": "Optioneel",
                    "mandatory": "Verplicht",
                    "total": "Totaal"
                },
                "qst": {
                    "history-recovery-notification": "{answerCount} antwoord/antwoorden hersteld uit de geschiedenis",
                    "no-history": "Geen geschiedenis beschikbaar",
                    "btn": {
                        "validate": "Valideren",
                        "history-recovery": "Historiek herstel"
                    }
                },
                "screen": {
                    "picture": {
                        "add": {
                            "title": "Foto toevoegen",
                            "form": {
                                "file": "Bestand uploaden (foto)"
                            }
                        },
                        "edit": {
                            "title": "Foto bewerken",
                            "form": {
                                "file": "Bestand uploaden (foto)"
                            }
                        },
                        "delete": {
                            "title": "Afbeelding verwijderen",
                            "text": "Weet u zeker dat u deze afbeelding wilt verwijderen?"
                        },
                        "forbidden-text": "Het is niet toegestaan om afbeeldingen te uploaden in deze vraag"
                    },
                    "element": {
                        "add": {
                            "title": "Nieuwe invoer toevoegen",
                            "text": "Voer alstublieft de gegevens in voor de nieuwe invoer",
                            "btn": "Toevoegen"
                        },
                        "delete": {
                            "title": "Invoer verwijderen",
                            "text": "Weet u zeker dat u deze invoer wilt verwijderen?"
                        }
                    },
                    "product": {
                        "list": {
                            "all": "Alle producten"
                        },
                        "filter": {
                            "search": "Zoeken in naam, merk, EAN",
                            "tags": "Filteren op tags",
                            "dno": "Filteren op DN / DNo",
                            "incomplete-products": "Onvolledige producten",
                            "missing-products-in-DN": "Ontbrekende producten in DN/DNo",
                            "out-of-stock-products": "Uitverkochte producten"
                        },
                        "sort": "Sorteren op"
                    },
                    "next-questionnaire": "Volgende vragenlijst",
                    "previous-questionnaire": "Vorige vragenlijst"
                }
            },
            "status": {
                "label": {
                    "new": "Indienen",
                    "toBeTransmitted": "Bezig met verzenden",
                    "transmitted": "Verzonden"
                },
                "cancel": "Annuleren"
            },
            "total-charts": {
                "title": {
                    "optional": "Optioneel",
                    "mandatory": "Verplicht",
                    "pictures": "Foto's",
                    "total": "Totaal"
                },
                "label": {
                    "optional-questions": "Optionele vragen",
                    "mandatory-questions": "Verplichte vragen",
                    "total-questions": "Alle vragen",
                    "answered-questions": "Beantwoorde vragen"
                }
            }
        },
        "info": {
            "contacts": {
                "title": "Mijn Winkel-contacten",
                "btn": "Contactbeheer"
            },
            "comment": {
              "title": "Mijn opmerkingen"
            },
            "informative-answer": {
                "title": "Instructies",
                "message": {
                    "no-instructions": "Er zijn geen gegevens",
                    "zero-item": "Geen instructies"
                }
            },
            "documents": {
              "title": "Mijn documenten"
            },
            "last-reading": {
                "title" : "Mijn laatste meting",
                "last-reading-date": "Datum laatste meting:",
                "message": {
                    "no-data": "Er zijn geen gegevens"
                },
                "missing-dno-products": "Ontbrekende producten in DNO",
                "out-of-stock-products": "Ruptuurproducten",
                "ean": "EAN",
                "product-name": "Productnaam",
                "category": "Categorie",
                "tags": "Tags",
                "not-missing": "Niet ontbrekend",
                "in-stock": "Op voorraad"
            },
            "flash-news": {
                "title": "Nieuwsflits"
            },
            "perfect-store": {
                "title": "Mijn Perfect Store",
                "no-data": "Er zijn geen gegevens"
            }
        },
        "actions": {
            "edit": {
                "title": "Bewerken",
                "form": {
                    "pos": "Verkooppunt",
                    "date": "Datum"
                },
                "validation": {
                    "pos": "Selecteer een verkooppunt",
                    "date": "Voeg een datum toe"
                },
                "alert": {
                    "unable-enter-date-in-the-past": "Het is niet mogelijk een datum in het verleden in te voeren",
                    "unable-enter-date-in-the-future": "Het is niet mogelijk een datum in de toekomst in te voeren"
                }
            },
            "delete": {
                "title": "Verwijderen",
                "text": "Weet u zeker dat u deze missie wilt verwijderen?"
            }
        },
        "filter": {
            "screen-by-category": {
                "brand": "Merk",
                "category": "Categorie"
            }
        },
        "statement-status": {
            "title": "Status van mijn opname:",
            "new": "Niet begonnen",
            "incomplete": "Onvolledig",
            "ready": "Te verzenden"
        },
        "warning": {
            "already-started-statement": "Een opname is al gestart op {date}",
            "readings-older-than-current-week-to-finish": "Opnames ouder dan de huidige week kunnen niet worden voltooid"
        }
    },
    "appointment": {
        "new": {
            "modal": {
                "title": "Nieuw bezoek",
                "create": "Aanmaken",
                "pdv": "Verkooppunt",
                "pdv-group": {
                    "planned": "Gepland",
                    "not-planned": "Niet gepland"
                },
                "configuration": "Klant",
                "configurations": "Configuraties",
                "type": "Type bezoek",
                "type-options": {
                    "unexpected": "Bezoek zonder afspraak",
                    "expected": "Bezoek met afspraak"
                },
                "time-options": {
                    "now": "Nu",
                    "later": "Later"
                },
                "datepicker-label": "Op",
                "timepicker-from": "Van",
                "timepicker-to": "tot",
                "timepicker-at": "om",
                "time-range": "tijdslot",
                "no-slot": "Geen beschikbaar tijdslot",
                "validation": {
                    "pdv": "Selecteer een verkooppunt",
                    "configuration": "Selecteer een klant",
                    "type": "Selecteer een type bezoek",
                    "date": "Selecteer een datum",
                    "time": "Selecteer een tijdslot",
                    "from": "Selecteer een begintijd",
                    "to": "Selecteer een eindtijd",
                    "need-higher-time": "De eindtijd mag niet eerder zijn dan de begintijd van het bezoek"
                }
            },
            "btn": {
                "title": "Nieuw bezoek"
            }
        }
    },
    "contact": {
        "list": {
            "title": "Contacten"
        },
        "filter": {
            "label": {
                "search": "Zoeken in naam, voornaam, telefoon",
                "pos": "Verkooppunten",
                "township": "Gemeenten",
                "department": "Departementen"
            }
        },
        "config-select": "Contact zoeken voor",
        "detail-title": "Contactdetail",
        "firstname": "Voornaam",
        "lastname": "Achternaam",
        "email": "E-mail",
        "job": "Functie",
        "phone": "Telefoon",
        "fax": "Fax",
        "comment": "Opmerking",
        "pos": "Verkooppunt",
        "shelf": "Afdeling",
        "delete-confirm": "Weet u zeker dat u dit contact wilt verwijderen?",
        "new-contact": "Nieuw contact",
        "edit-contact": "Contact bewerken",
        "validation": {
            "pos": "Selecteer een verkooppunt",
            "firstname": "Voer een voornaam in",
            "lastname": "Voer een achternaam in",
            "job": "Voer een functie in",
            "phone": "Het ingevoerde telefoonnummer is ongeldig",
            "email": "Het ingevoerde e-mailadres is ongeldig"
        }
    },
    "conditions-messages": {
        "or": " of ",
        "field-date": {
            "future": "Groter dan: {date}",
            "not-future": "Kleiner dan: {date}",
            "pastnday": "Min: {date}",
            "not-pastnday": "Max: {date}",
            "futurnday": "Max: {date}",
            "not-futurnday": "Min: {date}"
        },
        "value-comparison": {
            "eq": "De waarde moet gelijk zijn aan {value}",
            "not-eq": "De waarde mag niet gelijk zijn aan {value}",
            "gt": "Groter dan: {value}",
            "not-gt": "Kleiner dan: {value}",
            "gteq": "Min: {value}",
            "not-gteq": "Max: {value}",
            "lt": "Kleiner dan: {value}",
            "not-lt": "Groter dan: {value}",
            "lteq": "Max: {value}",
            "not-lteq": "Min: {value}",
            "in": "De waarde moet voorkomen in de lijst {value}",
            "not-in": "De waarde mag niet voorkomen in de lijst {value}",
            "true": "De waarde moet 'ja' zijn",
            "not-true": "De waarde mag niet 'ja' zijn",
            "int": "Geheel getal",
            "not-int": "Geen geheel getal",
            "floatn": "De waarde moet een decimaal getal zijn",
            "not-floatn": "De waarde mag geen decimaal getal zijn"
        }
    },
    "reading": {
        "bo-access": "Bekijk de details van de meting"
    },
    "event": {
        "new": {
            "btn": {
                "title": "Nieuw evenement"
            },
            "modal": {
                "title": "Evenement",
                "type": "Type",
                "date-start": "Van",
                "date-end": "Tot",
                "title-field": "Titel",
                "description": "Beschrijving",
                "create": "Aanmaken",
                "morning": "Ochtend",
                "afternoon": "Namiddag",
                "days-off-balance": "Uw saldo is {balance} verlofdagen",
                "provisional-balance": "Voorlopig saldo ({balance}d)",
                "pending-requests": "Uw openstaande aanvragen:",
                "pending-request-item": "{start} tot {end} ({days}d)",
                "no-pending-requests": "Geen openstaande aanvragen",
                "offline-error": "U moet online zijn om een evenement aan te maken",
                "reconnect-required": "Uw sessie is verlopen. Gelieve opnieuw in te loggen.",
                "reconnect-login": "Login",
                "reconnect-password": "Wachtwoord",
                "reconnect-submit": "Opnieuw verbinden",
                "reconnect-error": "Herverbinding mislukt. Controleer uw inloggegevens.",
                "insufficient-balance": "Onvoldoende verlofsaldo voor deze aanvraag",
                "creation-error": "Er is een fout opgetreden bij het aanmaken van het evenement",
                "validation": {
                    "type": "Selecteer een evenementtype",
                    "date-start": "Selecteer een startdatum",
                    "date-end": "Selecteer een einddatum",
                    "time-start": "Selecteer een starttijd",
                    "time-end": "Selecteer een eindtijd",
                    "time-quarter": "Minuten moeten 00, 15, 30 of 45 zijn",
                    "title": "Voer een titel in",
                    "date-end-before-start": "Einddatum kan niet vóór de startdatum liggen"
                }
            }
        },
        "edit": {
            "btn": {
                "title": "Evenement bewerken"
            },
            "modal": {
                "title": "Evenement bewerken",
                "save": "Opslaan",
                "update-error": "Evenement bijwerken mislukt",
                "offline-error": "U moet online zijn om een evenement te bewerken"
            }
        },
        "delete": {
            "btn": {
                "title": "Evenement verwijderen"
            },
            "confirm": {
                "title": "Evenement verwijderen",
                "message": "Weet u zeker dat u dit evenement wilt verwijderen? Deze actie kan niet ongedaan worden gemaakt.",
                "btn": "Verwijderen",
                "offline-error": "U moet online zijn om een evenement te verwijderen"
            }
        }
    }
}